import React from "react";
import { inject } from "mobx-react";
import {
  Button,
  Row,
  Col,
  Input
} from "reactstrap";
import { Box } from '@mui/system';
import FoldersTabComponent from "./FoldersTabComponent";
import LoadingComponent from "~/components/LoadingComponent";
import PaginationComponent from "~/components/PaginationComponent";
import { getVarFromUrl } from "../../../helpers/utils";
import { URL_APP_APP_BASE_PATH, URL_APP_BASE_PATH, PAGES_FOLDERS_TAB, PAGE_TYPE } from "../../../configs/constants";
import AlertComponent from "~/components/AlertComponent";

@inject("ImageStore", "DeviceStore", "PageStore")
class FoldersContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      images: [],
      searchText:""
    };
  }

  async componentDidMount() {
    this.getImages();
  }

  getImages = async (filter, skip) => {
    this.setState({
      isLoading: true,
    });
    if (skip === undefined) skip = 0;
    if (filter === undefined) filter = "";
    const { ImageStore } = this.props;
    const pageId = getVarFromUrl("pageId");

    let imagesAux = [];
    let countItems = 0;
    let currentPage = 1;
    let countPages = 1;

    if (pageId > 0) {
      const data = await ImageStore.getImages(pageId, PAGE_TYPE.folder, filter, skip); 
      if (data && data !== "" && data.images.length > 0) {
        imagesAux = data.images;
        countItems = data.countItems;
        countPages = data.countPages;
      }
    }
    this.setState({
      images: imagesAux,
      currentPage: currentPage,
      countItems: countItems,
      countPages: countPages,
      skip: skip,
      isLoading: false,
    });
  };

  findProducts = async (value) => {
    this.setState({
      searchText: value,
    });
    const { skip } = this.state;
    this.getImages(value, skip);
  };

  onClick = (imageId) => {
    const { history } = this.props;
    history.push(`folder?deviceId=${getVarFromUrl("deviceId")}&pageId=${getVarFromUrl("pageId")}&folderId=${imageId}&tab=${PAGES_FOLDERS_TAB}`);
  }

  onDelete = async (imageId) => {
    this.setState({
      isLoading: true
    });
    const { ImageStore, history } = this.props;
    await ImageStore.deleteImage(imageId);
    this.getImages();
    history.push(`page?deviceId=${getVarFromUrl("deviceId")}&pageId=${getVarFromUrl("pageId")}&tab=${PAGES_FOLDERS_TAB}`);
  };

  handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const { ImageStore } = this.props;
    const { images } = this.state;
    const items = Array.from(images);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    ImageStore.reorder(items);

    this.setState({
      images: items
    });
  };

  onPageChange = async (currentPage) => {  
    const skip = (currentPage - 1) * 100;
    await this.getImages(skip);
  };

  onView = async (image) => {
     window.open(URL_APP_APP_BASE_PATH + "?imageView=" + image.imageId);
  };

  onDownload = async (image) => {
    try {
      this.setState({
        isLoading: true
      });

      const response = await fetch(URL_APP_BASE_PATH.replace("api","view/image/") + image.imageId, {
        method: "GET",
      });

      if (!response.ok) throw new Error("Erro ao buscar imagem");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "cartaz.jpeg";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
      this.setState({
        isLoading: false
      });
    } catch (err) {
      console.error("Erro no download:", err);
    }
  };

  onDeleteAll = async () => {       
    this.setState({
      isLoading: true
    });

    const pageId = getVarFromUrl("pageId");
    const { ImageStore } = this.props;
    const result = await ImageStore.deleteAll(pageId);
    if (result === "true" || result === true){
      AlertComponent.success("Cartazes removidos com sucesso");
      this.getImages();
    } else {
      AlertComponent.error("Falha ao remover cartazes");
    }
    this.setState({
      isLoading: false
    });
  };

  render() {
    const { isLoading, images, searchText, currentPage, countItems } = this.state;
    return (
      <>
        {(isLoading && (
            <LoadingComponent />
        )) || (
          <>
            <br/>   
            <Row>
                <Col xs={12} md={8}>
                  <Input
                    name="code"
                    type="text"
                    placeholder="Parte do código ou parte do nome do produto"
                    value={searchText}
                    onChange={(e) => this.findProducts(e.target.value)}
                  />
              </Col>
                <Col xs={12} md={4} style={{textAlign: "right"}}>
                 <Button
                  className="btn-fill btn-xs"
                  color="danger"
                  type="submit"
                  onClick={()=> {
                    AlertComponent.dialog("Irá apagar todos os cartazes desta página.",
                      function dialoagNo() {
                      },
                      this.onDeleteAll,
                      true
                    );
                  }}
                >
                  Excluir todos
                </Button>
                <Button
                  className="btn-fill btn-xs"
                  color="primary"
                  type="submit"
                  onClick={()=>this.onClick(0)}
                >
                  Novo cartaz
                </Button>
              </Col>
            </Row>
            <br/>
            <Row>
              <Col xs={4} md={2}>
                Código
              </Col>
              <Col xs={4} md={5}>
                Produto
              </Col>
              <Col md={1}>
                <Box sx={{ display: { xs: 'none', md: 'block' } }}>Destaque</Box>
              </Col>        
              <Col md={1}>
                <Box sx={{ display: { xs: 'none', md: 'block' } }}>Preço</Box> 
              </Col>
            </Row>
            {(images && (
              <FoldersTabComponent
                images={images}
                onClick={this.onClick}
                onDelete={this.onDelete}
                onDownload={this.onDownload}
                onView={this.onView}
                handleOnDragEnd={this.handleOnDragEnd}
              />)
            )}
            {(images && (
              <PaginationComponent
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={countItems}
                onPageChange={this.onPageChange}
                pageSize={countItems}
              />)
            )}
          </>          
        )}
      </>
    );
  }
}

export default FoldersContainer;